// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"styles_tooltip__1g3vs","text":"styles_text__2tT_6","value":"styles_value__1w39h"};